import * as React from 'react';
import Dropzone from 'react-dropzone';
import '../../style/dropZone.css';
import Translator from '../Translator/Translator';

const downloadIcon = require('../../resource/img/upload.svg');
const pageSpinner = require('../../resource/img/page-loading.gif');

interface EnquiryDropZoneProps {
    onDrop: (file: Blob) => void,
    loading: boolean,
    disabled: boolean
}

class EnquiryDropZone extends React.Component <EnquiryDropZoneProps, {}> {
    public onDrop(file) {
        this.props.onDrop(file);
    }

    public render() {
        return (
            <div className={`dropZone${this.props.disabled ? " disabled" : ""}`}>
                <Dropzone onDrop={this.onDrop.bind(this)} accept="image/*" disabled={this.props.disabled}>
                    <div className="cmVerCenter dropZoneLabel">
                        <Translator path="enquiry.qrBox">Upload QR Code</Translator>
                    </div>
                    {this.props.loading && <img className="dropZoneLoading" src={pageSpinner}/>}
                    <img className="dropZoneIcon" src={downloadIcon}/>
                </Dropzone>
            </div>
        );
    }
}

export default EnquiryDropZone;



// WEBPACK FOOTER //
// ./src/Components/Enquiry/EnquiryDropZone.tsx